/****************************************************
 * Module Name:  RelabModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg';
import BiotechIcon from '@mui/icons-material/Biotech';

const RelabModal = ({
    show,
    setShow,
    handleSave,
    stoneIds,
    loading,
}) => {
    const saveHandler = () => {
        if (handleSave) {
            handleSave(stoneIds);
        }
    };

    const handleClose = () => {
        setShow(false);
    };

    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                size="lg"
                centered
                enforceFocus={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Re-Lab Stone
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        Are you sure you want to Relab these stones ?
                    </Typography>

                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loading}
                        loadingPosition="start"
                        variant="outlined"
                        color="success"
                        onClick={saveHandler}
                        type="Submit"
                        sx={{ mr: 3 }}
                        startIcon={<BiotechIcon size="large" />}
                    >
                        RE - LAB
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        sx={{ mr: 2 }}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default RelabModal;
